module.exports = __webpack_public_path__ + "img/MountaineeringBuckle.ea69a3a7.png";